export function getActivitiesPagePath(): string {
    return `/activities`;
}
